function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (root, factory) {
  'use strict';

  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object') {
    module.exports = factory;
  } else if (typeof define === 'function' && define.amd) {
    define(factory);
  } else {
    root.AutoHR = factory;
  }
})(this, function (MediumEditor) {
  var HR_TOKEN = '---';
  var AutoHR = MediumEditor.Extension.extend({
    name: 'autohr',
    init: function init() {
      this.subscribe('editableKeydownEnter', this.onInput.bind(this));
    },
    onInput: function onInput(evt) {
      var parentElement = this.base.getSelectedParentElement();

      if (parentElement.textContent === HR_TOKEN) {
        this.base.execAction('delete');
        this.base.execAction('delete');
        this.base.execAction('delete');
        this.base.execAction('insertHorizontalRule');
      }
    }
  });
  return AutoHR;
}(typeof require === 'function' ? require('medium-editor') : MediumEditor));